import { gql } from 'graphql-request'

export const EXPORT_SEARCH_DASHBOARD = gql`
  query ExportSearchDashboard($startDate: DateTime!, $endDate: DateTime!) {
    exportSearchDashboard(startDate: $startDate, endDate: $endDate)
  }
`
